import Vue from "vue"
import apiClient from "@/utils/cb-client"
import SectionsResolver from "@/utils/sections-resolver"
import GiftSectionsResolver from "@/utils/gift-sections-resolver"
import OneTimeCheckoutSectionsResolver from "@/utils/one-time-checkout-sections-resolver"
import vatHelper from "@/utils/vat-helper"
import gstHelper from "@/utils/gst-helper"
import { baseState, baseActions, baseMutations, baseGetters } from "@/store/common/base-config"
import { reorderFields } from "@/utils/helper-functions"
// TODO
// Need to have a base config and share it with hosted page config

const state = {
  ...baseState,
  checkout_new: {
    loaded: false,
    sections: []
  },
  current_step: "",
  steps: [],
  review_steps: [],
  optional_fields: {},
  one_time_checkout_config: {},
  open_full_review: false,
  tos_holder: {},
  legal_agreements: [],
  recaptcha_checkout: false
}

const SET_CHECKOUT_NEW_CONFIG = "SET_CHECKOUT_NEW_CONFIG";
const SET_STEPS = "SET_STEPS";
const SET_CURRENT_STEP = "SET_CURRENT_STEP";
const SET_OPTIONAL_FIELDS = "SET_OPTIONAL_FIELDS";
const SET_ONE_TIME_CHECKOUT_CONFIG = "SET_ONE_TIME_CHECKOUT_CONFIG";
const SET_TOS_HOLDER = "SET_TOS_HOLDER";
const SET_LEGAL_AGREEMENTS = "SET_LEGAL_AGREEMENTS";
const ENABLE_FULL_REVIEW = "ENABLE_FULL_REVIEW";
const SET_REVIEW_STEPS = "SET_REVIEW_STEPS";
const ADD_REVIEW_STEP = "ADD_REVIEW_STEP";
const SET_ALLOWED_ACTIONS = "SET_ALLOWED_ACTIONS";
const SET_NL_TEXTS = "SET_NL_TEXTS";
const SET_LOCALE = "SET_LOCALE";
const SET_CONFIG_LOCALE = "SET_CONFIG_LOCALE";
const SET_TEXTS = "SET_TEXTS";
const SET_RECAPTCHA_CHECKOUT = "SET_RECAPTCHA_CHECKOUT";
const SET_GIFT_CONFIG = "SET_GIFT_CONFIG";

const actions = {
  ...baseActions,
  load_checkout_config({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      if (!state.checkout_new.loaded) {
        try {
          var data = window.hpConfig;
          commit(SET_CHECKOUT_NEW_CONFIG, data.sections.reduce((o, section) => {
            section['fields'] = reorderFields(section.fields);
            o[section.type] = section;
            if (section.type == "billing_address") {
              if (section.tax_config) {
                vatHelper.setVatConfig(JSON.parse(section.tax_config));
              }
              if (section.gst_config) {
                gstHelper.setGstConfig(JSON.parse(section.gst_config));
              }
            }
            return o;
          }, {}));

          dispatch('set_base_config', data);
          commit(SET_OPTIONAL_FIELDS, data.optional_fields);
          commit(SET_ONE_TIME_CHECKOUT_CONFIG, data.one_time_checkout_config);
          commit(SET_LEGAL_AGREEMENTS, data.legal_agreements);
          commit(SET_ALLOWED_ACTIONS, data.allowed_actions);
          commit(SET_GIFT_CONFIG, data.gift_sub_config);
          resolve(true);
        } catch (error) {
          reject(error)
        };
      } else {
        resolve(true);
      }
    });
  },
  resync_texts({ rootState, commit, getters, dispatch }, options) {
    var promises = [];
    promises.push(apiClient.field_configs.retrieve_init_info(options.customer).then((data) => {
      commit(SET_NL_TEXTS, data.non_loggedin_texts);
      commit(SET_LOCALE, data.init_info_locale);
      if(window.Chargebee && window.Chargebee.getInstance()) {
        window.Chargebee.getInstance().setLocale(data.init_info_locale)
      }
      window.currency_list = data.currency_list;
    }));

    let cp;
    let params;
    if(getters.is_checkout_gift) {
      cp = apiClient.field_configs.gift_checkout(options.customer);
    } else if(getters.is_checkout_one_time) {
      params = {type : "checkout_one_time", locale: options.customer.locale};
    } else {
      params = {type : "checkout_new", locale: options.customer.locale};
    }
    if(!cp) cp = apiClient.field_configs.checkout(params);
    promises.push(cp.then((data) => {
      commit(SET_CONFIG_LOCALE, data.configuration_locale);
      commit(SET_TEXTS, data.txts);
      commit(SET_CHECKOUT_NEW_CONFIG, data.sections.reduce((o, section) => {
        section['fields'] = reorderFields(section.fields);
        o[section.type] = section;
        if (section.type == "billing_address" && section.tax_config) {
          vatHelper.setVatConfig(JSON.parse(section.tax_config));
        }
        if (section.type == "billing_address" && section.gst_config) {
          gstHelper.setGstConfig(JSON.parse(section.gst_config));
        }
        return o;
      }, {}))
    }));
    return Promise.all(promises);
  },
  resync_pm_list({rootState, dispatch}, options) {
    if(!rootState.auth.customer_handle) {
      logger.e("resync_pm_list called without customer_handle");
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      apiClient.gateway.retrieve({}, {
        entity_type: "CUSTOMER",
        entity_id: rootState.auth.customer_handle,
        locale: options.customer.locale
      }).then((data) => {
        dispatch('set_pm_list', data.pm_list);
        resolve(true);
      }).catch((error) => {
        logger.e(error);
        reject(error);
      });
    });
  },
  determine_steps({ commit, state, rootState, dispatch, getters, rootGetters }) {
    var sectionsResolver;
    if(getters.is_checkout_gift){
      sectionsResolver =  new GiftSectionsResolver();
    } else if(getters.is_checkout_one_time) {
      sectionsResolver = new OneTimeCheckoutSectionsResolver();
    } else {
      sectionsResolver = new SectionsResolver();
    }
    commit(SET_CURRENT_STEP, undefined);
    sectionsResolver.resolve(state, rootState, dispatch, getters, rootGetters);
    commit(SET_STEPS, [].concat(sectionsResolver.steps));
    commit(SET_REVIEW_STEPS, [].concat(sectionsResolver.review_steps));
    dispatch('set_next_step');
  },

  add_review_step({ commit, state }, review_step) {
    commit(ADD_REVIEW_STEP, review_step);
  },

  move_to_prev_step({ commit, state }) {
    if (state.current_step == "review") {
      if ((state.steps.length == 0) || (state.steps.length == 1 && state.review_steps.length == 1 && state.steps[0] == "payment_method")) {
        return;
      }
      commit(SET_CURRENT_STEP, state.steps[state.steps.length - 1]);
      return;
    }

    if (state.steps.length > 0) {
      let currentIndex = state.steps.indexOf(state.current_step);
      if (currentIndex > 0) {
        commit(SET_CURRENT_STEP, state.steps[currentIndex - 1]);
      }
    }
  },

  set_next_step({ commit, state, getters }) {
    if (state.current_step != "review") {
      if (!state.current_step) {
        if (getters.one_screen_checkout) {
          commit(SET_CURRENT_STEP, "review");
        } else if (state.steps.length == 0) {
          commit(SET_CURRENT_STEP, "review");
        } else {
          commit(SET_CURRENT_STEP, state.steps[0]);
        }
        return;
      }
      var index = state.steps.indexOf(state.current_step);
      // end of steps
      if (index == state.steps.length - 1) {
        commit(SET_CURRENT_STEP, "review");
      } else {
        commit(SET_CURRENT_STEP, state.steps[index + 1]);
      }
    } else {
      // shouldnt get called
    }
  },

  remove_step({commit, state}, step) {
    commit(SET_STEPS, state.steps.filter(i => i != step));
    commit(SET_REVIEW_STEPS, state.review_steps.filter(i => i != step));
  },

  enable_full_review({ commit, state }) {
    commit(ENABLE_FULL_REVIEW, true);
  },

  set_recaptcha_checkout({commit, state}, value) {
    commit(SET_RECAPTCHA_CHECKOUT,value)
  }
}

const mutations = {
  ...baseMutations,
  [SET_CHECKOUT_NEW_CONFIG](state, sections) {
    Vue.set(state.checkout_new, 'sections', sections);
    state.checkout_new.loaded = true;
  },

  [SET_RECAPTCHA_CHECKOUT] (state,recaptcha_checkout) {
    Vue.set(state, 'recaptcha_checkout', recaptcha_checkout);
  },

  [SET_STEPS] (state, steps) {
    Vue.set(state, 'steps', steps);
  },
  [SET_CURRENT_STEP](state, step) {
    Vue.set(state, 'current_step', step);
  },
  [ENABLE_FULL_REVIEW](state) {
    state.open_full_review = true;
  },
  [SET_OPTIONAL_FIELDS](state, optional_fields) {
    Vue.set(state, 'optional_fields', optional_fields);
  },
  [SET_ONE_TIME_CHECKOUT_CONFIG](state, data) {
    Vue.set(state, 'one_time_checkout_config', data);
  },
  [SET_TOS_HOLDER](state, tosHolder) {
    Vue.set(state, 'tos_holder', tosHolder);
  },
  [SET_LEGAL_AGREEMENTS](state,legal_agreements){
    Vue.set(state, 'legal_agreements', legal_agreements);
  },
  [SET_REVIEW_STEPS](state, review_steps) {
    Vue.set(state, 'review_steps', state.steps.concat(review_steps));
  },
  [ADD_REVIEW_STEP](state, step) {
    state.review_steps.push(step);
  },
  [SET_ALLOWED_ACTIONS](state, allowed_actions) {
    Vue.set(state, 'allowed_actions', allowed_actions);
  },
  [SET_GIFT_CONFIG](state, gift_config) {
    Vue.set(state, 'gift_config', gift_config);
  }
}

var flatten = (fields, output) => {
  fields.forEach(f => {
    !f.sub_fields ? output.push(f) : flatten(f.sub_fields, output);
  });
  return output;
}

var isAddressPartiallyFilled = (address, def_value) => {
    return (address.country || def_value) && (address.state || address.state_code) && address.line1;
}

const getters = {
  ...baseGetters,
  hosted_page_type: () => "checkout",
  checkout_config_loaded: state => state.checkout_new.loaded,
  checkout_steps: state => state.steps,
  checkout_review_steps: state => state.review_steps,
  checkout_sections: state => state.checkout_new.sections,
  gift_config: state => state.gift_config,
  checkout_sections_fields_flattened: (state, getters) => (fname) => {
    return getters.checkout_sections[fname] ? flatten(getters.checkout_sections[fname].fields, []) : []
  },
  current_checkout_step: state => state.current_step,
  translate: (state, getters) => (key) => {
    return getters.is_checkout_gift && state.texts['inapp_checkout.gift.' + key] != undefined ? state.texts['inapp_checkout.gift.' + key] : state.texts['inapp_checkout.' + key];
  },
  ctranslate: (state, getters) => (key) => getters.translate(key),
  stranslate: state => (key) => {
    return state.texts['hp_v3.inapp_checkout.' + key];
  },
  open_full_review: state => state.open_full_review,
  coupon_enabled: state => state.optional_fields.coupon,
  multi_coupon_enabled: (state, getters) => getters.coupon_enabled && (getters.can_allow("change-subscription.apply-coupon.action.allow_multiple") || getters.can_allow("one-time-checkout.apply-coupon.action.allow_multiple")),
  retain_pm_option: (state, getters) => {
    return state.one_time_checkout_config && state.one_time_checkout_config.retain_payment_source_one_time
  },
  tos_enabled: state => state.tos_holder && !!state.tos_holder.txt,
  tos_holder: state => state.tos_holder,
  legal_agreements_enabled: state => !!state.legal_agreements && state.legal_agreements.length > 0,
  legal_agreements: state => state.legal_agreements,
  email_requested: state => {
    return state.checkout_new.sections && state.checkout_new.sections.customer &&
      state.checkout_new.sections.customer.fields.filter(f => f.name == "email" && !f.read_only && f.required).length > 0
  },
  can_edit_cart: (state, getters) => {
    return getters.can_allow("change-subscription.action.allow_plan_quantity_update") || getters.can_allow("change-subscription.action.allow_add_addons") || getters.can_allow("change-subscription.action.allow_change_quantity_addons") || getters.can_allow("change-subscription.action.allow_remove_addons");
  },
  can_show_product_description: (state, getters) => {
    return getters.can_allow("change-subscription.action.show_product_description");
  },
  one_screen_checkout: (state,getters) => state.steps.length == 1 && state.review_steps.length == 1 && state.steps[0] == "payment_method" && (state.ui_config["hp_v3.quantity.custom_selection"] ? !getters.can_edit_cart : true),
  allowed_actions: state => state.allowed_actions || [],
  can_allow: (state, getters) => (action) => getters.allowed_actions.indexOf(action) > -1,
  autocomplete_enabled: (state, getters) => (pname) => state.checkout_new.sections[pname] && state.checkout_new.sections[pname].use_address_autocomplete,
  is_payless_checkout: state => state.recaptcha_checkout,
  skip_cart: (state, getters) => state.ui_config["cart_screen.skip"] && (state.ui_config["hp_v3.quantity.custom_selection"] ? !getters.can_edit_cart : true),
  allow_guest_checkout: state => state.ui_config["subscription.allow_multiple"] && state.ui_config["subscription.allow_guest"],
  excludeAddressForTaxCalculation: (state, getters, rootState) => () => {
    let onlyShipping = getters.authenticated;
    let shippingAddress = getters.selected_shipping_address;
    let countryConfig = getters.checkout_sections_fields_flattened('shipping_address').filter(f => f.name == "country")[0];
    if(shippingAddress && ["US", "CA"].indexOf(shippingAddress.country || (countryConfig && countryConfig.def_value)) > -1) {
      if(countryConfig && countryConfig.read_only && !isAddressPartiallyFilled(shippingAddress, countryConfig.def_value)) {
        return true;
      }
    }
    // if billing_address[country] is present and field config is readonly
    let billingAddress = rootState.customer.billing_address;
    let countryConfig1 = getters.checkout_sections_fields_flattened('billing_address').filter(f => f.name == "country")[0];
    if(!onlyShipping && billingAddress && ["US", "CA"].indexOf(billingAddress.country || (countryConfig1 && countryConfig1.def_value)) > -1) {
      if(countryConfig1 && countryConfig1.read_only && !isAddressPartiallyFilled(billingAddress, countryConfig1.def_value)) {
        return true;
      }
    }
    return false;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}